export const DagStyles = () => {
  return (
    <>
      <svg style={{ position: 'absolute', top: 0, left: 0 }}>
        <defs>
          <marker
            id="black-right-arrow"
            markerWidth="20"
            markerHeight="20"
            viewBox="-10 -10 20 20"
            markerUnits="strokeWidth"
            orient="auto-start-reverse"
            refX="0"
            refY="0"
          >
            <polyline
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              points="-5,-4 0,0 -5,4"
              style={{ stroke: 'var(--borderMainActive)', strokeWidth: 1 }}
            />
          </marker>
        </defs>
      </svg>
      <style>
        {`
          .react-flow__edge-interaction {
            pointer-events: none;
          }

          g {
            pointer-events: none;
          }

          svg {
            pointer-events: none;
          }
      `}
      </style>
    </>
  );
};
